module.exports = {
  hasOpenModal: function() {
    var fromEmail, hasCouponModalParam;
    fromEmail = /[?&]utm_medium=email($|&)/.test(window.location.search);
    hasCouponModalParam = (fromEmail && /[?&]ph=/.test(location.search)) || (!fromEmail && /[?&](c|ph)=/.test(location.search));
    return GIG.Modal.currentOpenModal().length || hasCouponModalParam;
  }
};

